import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';

import { CampoFormulario } from '../campo-formulario';

/**
 * Campo de texto del design system, de una línea o multilínea. Portado de
 * `InputTextComponent` del backoffice (`src/components/input-text/`), adaptado a
 * signals: la mecánica de formulario vive en [[CampoFormulario]] y acá queda la
 * plantilla.
 *
 * Se deja afuera todo lo que el portal no usa y que allá arrastra la mitad del
 * componente: los tipos `password` (con el ojo que alterna) e `image-upload`
 * (con su `FileReader` y sus validaciones de archivo), los iconos laterales, el
 * bloqueo de pegado y los links del label.
 *
 * El placeholder va en itálica siempre: en el backoffice es la clase
 * `placeholder-italic` que el formulario de contacto le pone campo por campo, y
 * acá el formulario de contacto es el único uso.
 */
@Component({
  selector: 'app-input-texto',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-texto.html',
  styleUrl: './input-texto.scss',
  host: {
    '[class]': '"campo campo--" + estado()',
  },
})
export class InputTexto extends CampoFormulario {
  readonly label = input<string>();
  readonly placeholder = input('');
  /** Textarea en vez de input de una línea. Se puede poner como `multilinea`. */
  readonly multilinea = input(false, { transform: booleanAttribute });

  /** Texto bajo el campo. Con el campo en error es el motivo del rechazo. */
  readonly textoAyuda = input('');

  /**
   * Tope de caracteres. Sin valor no se limita nada: el `maxLength = 100` que
   * el backoffice trae por defecto recortaba en silencio los mensajes largos.
   */
  readonly maxLargo = input<number>();

  /** Id propio, para que el `<label>` apunte a este campo y no a otro. */
  readonly idUnico = `input-texto-${Math.random().toString(36).slice(2, 11)}`;

  protected onInput(evento: Event): void {
    const campo = evento.target as HTMLInputElement | HTMLTextAreaElement;
    this.escribir(campo.value);
  }
}
